import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { useMediaQuery, useTheme } from '@material-ui/core';

interface TProps {
  caractersRecommandations: string[][];
}

export const PasswordRecommandations = ({
  caractersRecommandations,
}: TProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <S.StyledRecommandationsBlock isMobile={isMobile}>
      <S.StyledRecommandationsBlockTitle isMobile={isMobile}>
        {t('auth.createNewPassword.minNbOfCharacters')}
      </S.StyledRecommandationsBlockTitle>
      <S.StyledRecommandationsContent>
        {caractersRecommandations.map((recommandations) => {
          return (
            <ul>
              {recommandations.map((reco) => {
                return <li>{reco}</li>;
              })}
            </ul>
          );
        })}
      </S.StyledRecommandationsContent>
    </S.StyledRecommandationsBlock>
  );
};
